import TableDataNotFound from "component/TableDataNotFound";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { AppointmentStatus } from "utils/constants";
import {
  formatAppointmentCellValue,
  getClosingStatusTextColor,
  getCheckInStatusTextColor,
} from "utils/appointmentListStatusDisplay";
import { handleListResponse, seo } from "utils/utils";
import { errorToast } from "utils/httpClient";
import {
  getAppointmentList,
  getAppointmentListForAdmin,
} from "../../reduxStore/action/appointmentActions";
import {
  triggerWebhook,
  getSiteVisitStatusData,
} from "../../reduxStore/action/siteVisitActions";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import Select from "react-select";
import usePage from "utils/usePage";
import ExcelJS from "exceljs";

const AppointmentSiteVisit = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [appointmentData, setAppointmentData] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [page, setPage] = usePage();
  const dispatch = useDispatch();
  const appointmentListSelector = useSelector((state) => state.appointment);
  const { loading, response, response1 } = appointmentListSelector;
  const ReportListSelector = useSelector((state) => state.report);
  const propertySelector = useSelector((state) => state.propertyData) || {};
  const [res, setRes] = useState(true);
  const [webhookLoadingMap, setWebhookLoadingMap] = useState({});
  const [showWebhookModal, setShowWebhookModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const siteVisitSelector = useSelector((state) => state?.siteVisit);
  const hasCheckin = (checkinStatus) => {
    if (!checkinStatus) return false;
    if (Array.isArray(checkinStatus)) return checkinStatus.length > 0;
    return typeof checkinStatus === "object";
  };

  /** Closing column: when a Revisit row is checked in but has no disposition title yet, do not fall back to status "Revisit". */
  const getClosingStatusLabel = (item, showAsVisited) => {
    if (showAsVisited && Number(item?.status) === 2) {
      const cs = String(item?.closing_status || "")
        .trim()
        .toLowerCase();
      if (!cs || cs === "not updated" || cs === "revisit") return "";
    }
    if (
      item?.closing_status !== null &&
      item?.closing_status !== undefined &&
      String(item.closing_status).trim() !== ""
    ) {
      return item.closing_status;
    }
    if (showAsVisited && Number(item?.status) === 2) {
      return "";
    }
    return Number(item?.status) === 1
      ? moment() >=
        moment(
          moment(item.appointment_date).utc().format("DD-MM-yyyy") +
            " " +
            item.appointment_time,
          "DD-MM-yyyy hh:mm A",
        )
        ? "Notvisited"
        : "Upcoming"
      : Number(item?.status) === 3
        ? "Upcoming"
        : AppointmentStatus[item?.status];
  };

  const { view, create, edit, isAdmin } = usePermission({
    view: "view_appointment _site_visite",
    create: "add_appointment _site_visite",
    edit: "edit_appointment _site_visite",
  });

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    appointment_with: "",
    customer_name: "",
    status: "",
    property_name: "",
  });
  useLayoutEffect(() => {
    if (!isAdmin) {
      dispatch(
        getAppointmentList({ appointment_type: 2, limit: 10, offset: page }),
      );
    }
  }, [dispatch, isAdmin, page]);

  // Reset data on refresh or page navigation
  useEffect(() => {
    // Reset data on component mount or page refresh
    const isFormIncomplete =
      !form.start_date &&
      !form.end_date &&
      !form.customer_name &&
      !form.status &&
      !form?.site?.property_title;

    if (isFormIncomplete && isAdmin) {
      dispatch(getAppointmentListForAdmin({ noData: true }));
    }
  }, [dispatch]);

  useEffect(() => {
    const responseData = isAdmin ? response1 : response;
    if (responseData?.status === 200) {
      setRes(false);

      const data = responseData?.data || [];

      if (data.length > 0) {
        setAppointmentData(handleListResponse(data) ? data : []);
      } else {
        setAppointmentData([]);
      }
    } else if (responseData?.status === 201) {
      setRes(true);

      setAppointmentData([]);
    } else {
      setRes(true);
      setAppointmentData([]);
    }
  }, [appointmentListSelector, isAdmin, response, response1, res]);

  useEffect(() => {
    if (isAdmin) {
      const { reportPropertyList } = ReportListSelector;
      if (reportPropertyList) {
        if (reportPropertyList?.status === 200) {
          setPropertyList(handleListResponse(reportPropertyList.data));
        } else {
          setPropertyList([]);
        }
      }
    }
  }, [ReportListSelector]);

  useEffect(() => {
    if (propertySelector.response) {
      if (
        propertySelector?.response &&
        propertySelector?.response.status === 200
      ) {
        const filteredData = propertySelector?.response?.data?.filter(
          (item) => item.status === true,
        );
        if (filteredData?.length > 0) {
          setPropertyList(handleListResponse(filteredData));
        } else {
          setPropertyList([]); // Clear the list if no valid data
        }
      } else {
        setPropertyList([]);
      }
    }
  }, [dispatch, propertySelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      const appointmentParams = {
        appointment_type: 2,
        limit: 10,
        offset: 0,
        start_date: form.start_date,
        end_date: form.end_date,
        appointment_with: form.appointment_with,
        customer_name: form.customer_name,
        status: form.status,
        property_name: form?.site?.property_title,
        noData: false,
      };

      if (isAdmin) {
        dispatch(getAppointmentListForAdmin(appointmentParams));
      } else {
        dispatch(getAppointmentList(appointmentParams));
      }

      setPage(0);
    }
  };
  const filterReset = () => {
    setRes(true);
    setForm({
      start_date: "",
      end_date: "",
      appointment_with: "",
      customer_name: "",
      status: "",
      property_name: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    if (isAdmin) {
      dispatch(getAppointmentListForAdmin({ noData: true }));
    } else {
      dispatch(
        getAppointmentList({ appointment_type: 2, limit: 10, offset: 0 }),
      );
    }
    setRes(false);
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    if (isAdmin) {
      dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
    } else {
      dispatch(getAgentProperty({ offset: 0, limit: "" }));
    }
  }, [dispatch]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getAppointmentList({
        appointment_type: 2,
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        appointment_with: form.appointment_with,
        customer_name: form.customer_name,
        status: form.status,
        property_name: form?.site?.property_title,
      }),
    );
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Appointment Listing",
      metaDescription: "Appointment listing",
      canonicalLink: window.location.href,
    });
  }, []);

  // Handle webhook trigger
  const handleTriggerWebhook = async (appointment) => {
    const appointmentId = appointment._id;
    setWebhookLoadingMap((prev) => ({ ...prev, [appointmentId]: true }));

    try {
      // First, get the site visit mapping
      const statusDataRes = await dispatch(
        getSiteVisitStatusData({ appointment_id: appointmentId }),
      );

      if (statusDataRes?.data?.length > 0) {
        const mapping = statusDataRes.data[0];
        if (mapping.jv_site_visit_id) {
          const webhookRes = await dispatch(
            triggerWebhook({ jv_site_visit_id: mapping.jv_site_visit_id }),
          );
          if (webhookRes) {
            // Refresh the appointment list
            if (isAdmin) {
              dispatch(
                getAppointmentListForAdmin({
                  appointment_type: 2,
                  limit: 10,
                  offset: page,
                  start_date: form.start_date,
                  end_date: form.end_date,
                  appointment_with: form.appointment_with,
                  customer_name: form.customer_name,
                  status: form.status,
                  property_name: form?.site?.property_title,
                  noData: false,
                }),
              );
            } else {
              dispatch(
                getAppointmentList({
                  appointment_type: 2,
                  limit: 10,
                  offset: page,
                }),
              );
            }
          }
        } else {
          errorToast("Site visit mapping not found");
        }
      } else {
        errorToast("Site visit mapping not found for this appointment");
      }
    } catch (err) {
      console.error("Error triggering webhook:", err);
      errorToast("Error triggering webhook");
    } finally {
      setWebhookLoadingMap((prev) => ({ ...prev, [appointmentId]: false }));
      setShowWebhookModal(false);
      setSelectedAppointment(null);
    }
  };

  const handleShowWebhookModal = (appointment) => {
    setSelectedAppointment(appointment);
    setShowWebhookModal(true);
  };

  const handleCloseWebhookModal = () => {
    setShowWebhookModal(false);
    setSelectedAppointment(null);
  };

  const exportToExcel = async () => {
    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Appointments");

    // Define columns for Excel
    worksheet.columns = [
      { header: "Sr.No", key: "srno", width: 10 },
      { header: "Created Date & Time", key: "createdDate", width: 25 },
      { header: "Site Visit Time & Date", key: "siteVisit", width: 25 },
      { header: "Property Name", key: "property", width: 25 },
      { header: "Customer Name", key: "customer", width: 20 },
      { header: "Source", key: "source", width: 20 },
      { header: "Closing Status", key: "closingStatus", width: 20 },
      { header: "Check-In Status", key: "checkInStatus", width: 20 },
      { header: "Visiting Score", key: "visitingScore", width: 15 },
    ];

    // Map appointment data to rows
    const data = appointmentData.map((item, index) => {
      const chekin = hasCheckin(item?.checkin_status);
      const siteVisitStatus = item?.site_visit_status;
      const isVisitedFromMapping =
        siteVisitStatus === "Visited" ||
        siteVisitStatus === "Completed" ||
        siteVisitStatus === "Site Visit Done";
      const showAsVisited = chekin || isVisitedFromMapping;

      // Convert the appointment date to a readable format
      const siteVisitTime = item.appointment_date
        ? moment(item.appointment_date).utc().format("DD-MM-yyyy") +
          " & " +
          (item.appointment_time || "")
        : "";
      const createdDate = item.createdDate
        ? moment(item.createdDate).format("DD-MM-yyyy hh:mm A")
        : "";
      const closingRaw = getClosingStatusLabel(item, showAsVisited);
      const closingStatus = formatAppointmentCellValue(closingRaw);

      // Return row data
      return {
        srno: index + 1,
        createdDate: formatAppointmentCellValue(createdDate),
        siteVisit: formatAppointmentCellValue(siteVisitTime),
        property: formatAppointmentCellValue(item?.property_title),
        customer: formatAppointmentCellValue(
          `${item?.customer_first_name || ""} ${item?.customer_last_name || ""}`.trim(),
        ),
        source: formatAppointmentCellValue(item?.create_by),
        closingStatus: closingStatus,
        checkInStatus: formatAppointmentCellValue(
          showAsVisited ? "Visited" : "",
        ),
        visitingScore: formatAppointmentCellValue(item?.lead_score),
      };
    });

    // Add rows to the worksheet
    worksheet.addRows(data);

    worksheet.getRow(1).font = { bold: true };
    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a Blob object with the Excel file content
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a temporary download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "appointments_report.xlsx"; // The filename of the Excel file
    link.click();
  };
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.appointment}
        titleactive={strings.appointmentList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByCustomerName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              placeholder={strings.searchCustomerName}
                              type="text"
                              autoComplete="off"
                              name="customer_name"
                              value={form.customer_name}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="status"
                            value={form.status}
                            onChange={handleInputField}
                          >
                            <option value={""}>{strings.selectstatus}</option>
                            <option value={1}>{strings.panding}</option>
                            <option value={2}>{strings.revisit}</option>
                            <option value={3}>{strings.actualvisit}</option>
                            <option value={4}>{strings.visitcancelled}</option>
                            <option value={5}>{strings.rescheduled}</option>
                            <option value={6}>{strings.notfitforseal}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByPropertyName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (isAdmin) {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    }),
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {!isAdmin && create && (
              <div className="row pt-3">
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/add_appointment")}
                    >
                      {strings.addAppointment}
                    </button>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/today_appointments")}
                    >
                      {strings.todayAppointments}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isAdmin && (
              <div className="d-flex justify-content-end mb-4">
                <button className="btn btn-primary" onClick={exportToExcel}>
                  Export to Excel
                </button>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listofappointment}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.siteVisitTimeDate}</th>
                          <th scope="col">{strings.property_name}</th>
                          <th scope="col">{strings.customerName}</th>
                          {/* <th scope="col">{strings.pickup}</th> */}
                          <th scope="col">{strings.source} </th>
                          <th scope="col">{strings.closingStatus}</th>
                          <th scope="col">{strings.checkInStatus}</th>
                          <th scope="col">{strings.visitingScore}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {appointmentData?.length > 0 ? (
                          appointmentData.map((item, index) => {
                            const chekin = hasCheckin(item?.checkin_status);
                            const siteVisitStatus = item?.site_visit_status;
                            const isVisitedFromMapping =
                              siteVisitStatus === "Visited" ||
                              siteVisitStatus === "Completed" ||
                              siteVisitStatus === "Site Visit Done";
                            const showAsVisited =
                              chekin || isVisitedFromMapping;
                            return (
                              <tr key={index}>
                                <td>
                                  {formatAppointmentCellValue(
                                    item.createdDate
                                      ? moment(item.createdDate).format(
                                          "DD-MM-yyyy hh:mm A",
                                        )
                                      : "",
                                  )}
                                </td>
                                <td>
                                  {formatAppointmentCellValue(
                                    item.appointment_date
                                      ? moment(item.appointment_date)
                                          .utc()
                                          .format("DD-MM-yyyy") +
                                          " & " +
                                          (item.appointment_time || "")
                                      : "",
                                  )}
                                </td>
                                <td style={{ inlineSize: "130px" }}>
                                  {formatAppointmentCellValue(
                                    item?.property_title,
                                  )}
                                </td>
                                <td style={{ inlineSize: "130px" }}>
                                  {formatAppointmentCellValue(
                                    `${item?.customer_first_name || ""} ${item?.customer_last_name || ""}`.trim(),
                                  )}
                                </td>
                                <td style={{ inlineSize: "130px" }}>
                                  {formatAppointmentCellValue(item?.create_by)}
                                </td>
                                <td
                                  style={{
                                    color: getClosingStatusTextColor(
                                      getClosingStatusLabel(
                                        item,
                                        showAsVisited,
                                      ),
                                    ),
                                    fontWeight: "600",
                                  }}
                                >
                                  {formatAppointmentCellValue(
                                    getClosingStatusLabel(item, showAsVisited),
                                  )}
                                </td>
                                <td
                                  style={{
                                    color:
                                      getCheckInStatusTextColor(showAsVisited),
                                    fontWeight: "600",
                                  }}
                                >
                                  {formatAppointmentCellValue(
                                    showAsVisited ? "Visited" : "",
                                  )}
                                </td>
                                <td>
                                  {formatAppointmentCellValue(item?.lead_score)}
                                </td>
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title={"View Appointment"}
                                      onClick={() =>
                                        navigatpage(
                                          `/viewappointment/${item._id}`,
                                        )
                                      }
                                    ></i>
                                  )}
                                  {item.status === 1
                                    ? !isAdmin &&
                                      edit && (
                                        <i
                                          className="fa fa-edit theme-fa-icon p-1"
                                          aria-hidden="true"
                                          title="Edit Appointment"
                                          onClick={() =>
                                            navigatpage(
                                              `/editappointment/${item._id}`,
                                            )
                                          }
                                        ></i>
                                      )
                                    : ""}
                                  {/* Send to LMS button - Show when checked in and status is 3 */}
                                  {chekin && Number(item?.status) === 3 && (
                                    <i
                                      className="fa fa-paper-plane theme-fa-icon p-1"
                                      aria-hidden="true"
                                      title="Send to LMS"
                                      onClick={() =>
                                        handleShowWebhookModal(item)
                                      }
                                      style={{
                                        cursor: webhookLoadingMap[item._id]
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: webhookLoadingMap[item._id]
                                          ? 0.5
                                          : 1,
                                      }}
                                    ></i>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    {!response1 && isAdmin ? (
                      <div className="text-center mt-4 mb-3">
                        Please apply filter to view data
                      </div>
                    ) : !response && !response1 ? (
                      <div className="text-center mt-4 mb-3">Loading...</div>
                    ) : isAdmin && res === true ? (
                      <div className="text-center mt-4 mb-3">
                        Please apply filter to view data
                      </div>
                    ) : appointmentData.length === 0 ? (
                      <div className="text-center mt-4 mb-3">
                        No data available
                      </div>
                    ) : (
                      // Render your content here when appointmentData has items
                      <div>{/* Your data rendering logic goes here */}</div>
                    )}
                  </div>

                  {!isAdmin && (
                    <Pagination
                      totalCount={appointmentListSelector?.response?.total_data}
                      listData={appointmentData}
                      onPageChange={handlePageClick}
                      itemOffset={page}
                      setItemOffset={setPage}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Webhook Confirmation Modal */}
      {showWebhookModal && selectedAppointment && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            animation: "fadeIn 0.1s ease-in-out",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog"
            role="document"
            style={{
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send to LMS</h5>
                <button
                  className="close"
                  type="button"
                  onClick={handleCloseWebhookModal}
                  aria-label="Close"
                  disabled={webhookLoadingMap[selectedAppointment?._id]}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>Are you sure you want to send this visit to LMS?</h6>
                  <p className="text-muted mt-2">
                    This will trigger a webhook to send the site visit status
                    update to the LMS system.
                  </p>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-success mr-5"
                  type="button"
                  onClick={() => handleTriggerWebhook(selectedAppointment)}
                  disabled={webhookLoadingMap[selectedAppointment?._id]}
                >
                  {webhookLoadingMap[selectedAppointment?._id]
                    ? "Sending..."
                    : "Yes, Send"}
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleCloseWebhookModal}
                  disabled={webhookLoadingMap[selectedAppointment?._id]}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AppointmentSiteVisit;
